var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Button from 'shared-assets/components/Elements/Button';
import Menu from 'shared-assets/components/Menu';
var defaultProps = {
    onEdit: function () { },
    onRemove: function () { },
    onToggleDetails: function () { },
};
export default function ActionsMenu(props) {
    var _a = __assign(__assign({}, defaultProps), props), onEdit = _a.onEdit, onRemove = _a.onRemove, onToggleDetails = _a.onToggleDetails, showingDetails = _a.showingDetails;
    return (React.createElement(Menu, { className: "link", id: "actions-menu", direction: "down", position: "left", options: [
            React.createElement(React.Fragment, null,
                React.createElement(Button, { className: "link", type: "button", onClick: function () {
                        onEdit();
                    } }, "Edit"),
                React.createElement(Button, { className: "link", type: "button", onClick: function () {
                        onRemove();
                    } }, "Remove"),
                React.createElement(Button, { className: "link", type: "button", onClick: function () {
                        onToggleDetails();
                    } },
                    showingDetails ? 'Hide' : 'Show',
                    " Details")),
        ] }, "Actions"));
}
